export const TEXT_TYPES = {
  H1: "ee__h1",
  H2: "ee__h2",
  H3_500: "ee__h3__500",
  H3_700: "ee__h3__700",
  H4_500: "ee__h4__500",
  H4_700: "ee__h4__700",
  H5_500: "ee__h5__500",
  H5_700: "ee__h5__700",
  BODY1: "ee__body1", // 메뉴 타이틀
  BODY2: "ee__body2", // 서브 타이틀
  BODY3: "ee__body3", // 서브 타이틀, 팝업 타이틀
  LOGOUT: "ee__logout",
  SIDE_BAR: "ee_side-bar",
};

export type TextType = keyof typeof TEXT_TYPES;
